import React from 'react';
import {
  Card,
  CardContent,
  CardMedia,
  Typography,
  Grid,
  Box,
  IconButton,
  Chip,
} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import PublicIcon from '@mui/icons-material/Public';
import FlagIcon from '@mui/icons-material/Flag';

const StudentList = ({ students, onEdit, onDelete, isAdmin }) => {
  return (
    <Grid container spacing={3}>
      {students.map((student) => (
        <Grid item xs={12} sm={6} md={4} key={student.id}>
          <Card>
            {student.picture_url && (
              <CardMedia
                component="img"
                height="200"
                image={student.picture_url}
                alt={`${student.first_name} ${student.last_name}`}
                sx={{ objectFit: 'cover' }}
              />
            )}
            <CardContent>
              <Box display="flex" justifyContent="space-between" alignItems="flex-start" mb={1}>
                <Typography variant="h6" component="div">
                  {student.first_name} {student.last_name}
                </Typography>
                {student.achievement_type && (
                  <Chip
                    icon={student.achievement_type === 'International' ? <PublicIcon /> : <FlagIcon />}
                    label={student.achievement_type === 'International' ? 'Олон улсын' : 'Үндэсний'}
                    size="small"
                    color={student.achievement_type === 'International' ? 'primary' : 'success'}
                  />
                )}
              </Box>
              {student.achievements && (
                <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
                  {student.achievements}
                </Typography>
              )}
              {isAdmin && (
                <Box mt={2} display="flex" gap={1}>
                  <IconButton
                    color="primary"
                    size="small"
                    onClick={() => onEdit(student)}
                  >
                    <EditIcon />
                  </IconButton>
                  <IconButton
                    color="error"
                    size="small"
                    onClick={() => onDelete(student.id)}
                  >
                    <DeleteIcon />
                  </IconButton>
                </Box>
              )}
            </CardContent>
          </Card>
        </Grid>
      ))}
    </Grid>
  );
};

export default StudentList;

